export default "__VITE_ASSET__BGdSpTYq__"